// Google AdSense configuration.
//
// Auto Ads only scan the DOM on a full page load, so on a client-side route
// change they never run again. Every ad on the site is therefore an explicit
// unit rendered by <AdUnit name="..." />, which re-requests on navigation.
//
// To fill in a slot id: AdSense → Ads → By ad unit → Display ads → create a
// unit, then copy the `data-ad-slot` number out of the snippet Google shows.
// A slot left as null renders nothing in production, so an unconfigured unit
// can never ship a broken <ins> that AdSense would log errors against.

export const ADSENSE_CLIENT = "ca-pub-9224492704181016";

export const AD_SLOTS = {
    // Homepage, between the product grid and the flash-sale banner.
    homeMid: null,
    // Homepage, above the newsletter block.
    homeBottom: null,
    // /blog listing, under the page header.
    blogList: null,
    // Top of every blog article, between the hero image and the first paragraph.
    articleTop: null,
};
